import type {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { isString } from 'lodash';
import { DateTime } from 'luxon';
import type { OnyxTime } from '../components/timepicker/interfaces';

export const onyxMinTimeValidator =
  (min: DateTime | OnyxTime = DateTime.now()): ValidatorFn =>
  (control: AbstractControl<OnyxTime>): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;

    const minTime = isString(min) ? min : min.toFormat('HH:mm:ss');
    return value < minTime ? { minTime: minTime.slice(0, 5) } : null;
  };
